"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AccountIcon;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));
function AccountIcon(props) {
  let path = /*#__PURE__*/_react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, "Ic\xF4ne d'utilisateur"), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M332 392c0 99.252 80.748 180 180 180s180-80.748 180-180-80.748-180-180-180-180 80.748-180 180zM652 392c0 77.196-62.804 140-140 140s-140-62.804-140-140 62.804-140 140-140 140 62.804 140 140z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M900 184c0 11.046-8.954 20-20 20s-20-8.954-20-20c0-11.046 8.954-20 20-20s20 8.954 20 20z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M512 1024c283.808 0 512-229.854 512-512 0-93.938-25.612-185.768-74.062-265.564-5.732-9.44-18.030-12.446-27.476-6.716-9.442 5.734-12.448 18.034-6.714 27.476 44.65 73.538 68.252 158.19 68.252 244.804 0 136.856-57.542 263.792-158.952 353.366-30.872-145.618-159.992-253.366-313.048-253.366s-282.19 107.76-313.030 253.384c-101.422-89.584-158.97-216.526-158.97-353.384 0-260.262 211.738-472 472-472 105.978 0 206.062 34.23 289.432 98.992 8.722 6.776 21.288 5.196 28.064-3.526s5.198-21.288-3.526-28.064c-90.452-70.264-199.022-107.402-313.97-107.402-136.872 0-265.476 53.232-362.126 149.888-96.648 96.652-149.874 225.252-149.874 362.112 0 282.858 228.918 512 512 512zM512 652c141.394 0 258.762 103.28 277.444 242.014-80.91 58.906-176.586 89.986-277.444 89.986-100.848 0-196.512-31.084-277.422-89.992 18.656-138.732 136.012-242.008 277.422-242.008z"
  }));
  return path;
}
